import MuiAutocompleteField, {
  type AutocompleteProps,
} from '@mui/material/Autocomplete';
import { FormControl, InputLabel } from '@src/components/form';
import React from 'react';

import TextField from './TextField';

type AutocompleteOption = {
  label: string;
  value: string | number;
};

type AutocompleteFieldProps = Omit<
  AutocompleteProps<AutocompleteOption, false, false, false>,
  'renderInput' | 'value' | 'options' | 'onChange'
> & {
  value?: AutocompleteOption['value'] | null;
  options: AutocompleteOption[];
  onChange: (value: AutocompleteOption['value'] | null) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  label?: React.ReactNode;
};

const AutocompleteField = React.forwardRef<
  HTMLDivElement,
  AutocompleteFieldProps
>((props, ref) => {
  const {
    value,
    options,
    onChange,
    error,
    helperText,
    label,
    sx,
    ...restProps
  } = props;
  const selected = options.find((o) => o.value === value) ?? null;
  const fieldOnChange = (
    _: React.SyntheticEvent,
    option: AutocompleteOption | null,
  ) => {
    const selectedValue = option ? option.value : null;
    onChange(selectedValue);
  };

  return (
    <FormControl fullWidth sx={sx} error={error}>
      <InputLabel error={error}>{label}</InputLabel>

      <MuiAutocompleteField
        ref={ref}
        value={selected}
        options={options}
        onChange={fieldOnChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            helperText={helperText}
            error={error}
          />
        )}
        {...restProps}
      />
    </FormControl>
  );
});
AutocompleteField.displayName = 'AutocompleteField';
export default AutocompleteField;
